import Truck from '../images/truck2bg.png';

export default function Tsolutions(){
    return(
        <div style={{marginBottom:"100px"}}>
            <div style={{fontSize: "40px",backgroundColor: "white", color: "black", textAlign: "center", margin: "50px"}}>
                <h2 style={{fontSize: "60px",backgroundColor: "white", color: "blue", textAlign: "center", margin: "40px", fontWeight:"600"}}>Comprehensive Logistic Solutions</h2>
            </div>
            <div className="row">
                <div className="col-sm-4" style={{backgroundColor: "black", color: "white", padding: "40px", margin:"0px"}}>
                        <h5 style={{fontSize:"20px", marginTop: "30px", marginBottom:"30px"}}>LOGISTICS INTERNATIONAL</h5>
                        <p style={{fontSize:"30px"}}>Providing door to door logistics & cargo solutions</p>
                        <br />
                        
                </div>

                <div className='col-sm-8' style={{backgroundColor: "blue", color: "white", padding: "5px", margin:"0px"}}>
                    <img className="truck" src={Truck} alt='3 Keys Logistics' width='80%' />
                </div>

            </div>
        </div>
    );
}